let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("6QXPb")]).then(() => parcelRequire('6ccC4'));